var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFarmaSep = function SvgFarmaSep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.946 1.555a5.309 5.309 0 0 0-7.508 0L7.612 6.381l-5.897 5.9a5.309 5.309 0 0 0 7.506 7.508l5.9-5.897 4.825-4.828a5.313 5.313 0 0 0 0-7.509ZM8.15 18.715a3.792 3.792 0 0 1-5.363-5.363L7.612 8.53l5.36 5.363-4.823 4.823Zm7.03-15.628L10.867 7.4A.762.762 0 1 1 9.79 6.323l4.312-4.312a.762.762 0 0 1 1.078 1.076Z",
    fill: "#fff"
  })));
};

export default SvgFarmaSep;